export const referralsConstants = {
  SET_REFERRALS_SUCCESS: 'SET_REFERRALS_SUCCESS',
  SET_REFERRALS_FAILURE: 'SET_REFERRALS_FAILURE',
};
